import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-79543b53"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["innerHTML"]

import { ref, render, watchEffect } from 'vue'
import i18next from 'i18next';
import MarkdownIt from 'markdown-it'


export default /*#__PURE__*/_defineComponent({
  __name: 'ManualViewer',
  props: {
    section: null
  },
  setup(__props: any) {

const props = __props as {
  section?: string
};



const renderedMarkdown = ref('')
const md = new MarkdownIt()

watchEffect(async () => {
  const lang = i18next.language || 'en'
  const res = await fetch(`/manuals/${lang}.md`)
  console.log(res);
  const raw = await res.text()

  if (!props.section) {
    renderedMarkdown.value = md.render(raw)
    return
  }

  const regex = new RegExp(`## ${props.section}[\\s\\S]*?(?=\\n## |$)`, 'i')
  const match = raw.match(regex)
  renderedMarkdown.value = md.render(match?.[0] || `## ${props.section}\n_Section not found._`)
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    innerHTML: renderedMarkdown.value,
    class: "markdown-body"
  }, null, 8, _hoisted_1))
}
}

})